import { Action, createReducer, on } from '@ngrx/store';
import { setGatewaySessionTokenAction } from './gateway-session-token.actions';
import { GatewaySessionTokenState, initialState } from './gateway-session-token.state';

const reducer = createReducer(
  initialState,
  on(setGatewaySessionTokenAction, (state, { token }) => ({
    ...state,
    token,
    loaded: true,
    loading: false,
    errorLoading: false,
  }))
);

export function gatewaySessionTokenReducer(state: GatewaySessionTokenState, action: Action): GatewaySessionTokenState {
  return reducer(state, action);
}
